module.exports = __webpack_public_path__ + "media/pŏm mâi kâo jai jing loie.1d3ad3a6.mp3";